// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-upload-dragger {\n  width: 490px !important;\n}\n.el-dialog__body {\n  padding: 10px 20px 20px 20px !important;\n}\n.el-table .el-table__body td.is-change {\n  background: #ffff9f;\n}\n", ""]);
// Exports
module.exports = exports;
